@let coupledConnector = coupledConnector$ | async;
<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title> {{ template?.displayName || template?.target || '' }} Setup</div>

  @if (isTestableConnection()) {
    <ng-container actions>
      <blaze-environment-indicator class="mr-6" />
      <blaze-copy-connector-config-env-button
        (copyConfiguration)="copyConfiguration($event)"
        [coupledConnector]="coupledConnector"
      />
      @if ((isConnectionValid$ | async) === false) {
        <button (click)="testConnector()" blazeBarButton="primary"> test connection</button>
      }
      @if ((isConnectionValid$ | async) === true) {
        <button (click)="showNext.emit()" blazeBarButton="primary"> next</button>
      }
    </ng-container>
  }
  @if (!isTestableConnection() && isCreateOrUpdate()) {
    <ng-container actions>
      <blaze-environment-indicator class="mr-6" />
      <blaze-copy-connector-config-env-button
        (copyConfiguration)="copyConfiguration($event)"
        [coupledConnector]="coupledConnector"
      />
      <button (click)="createOrUpdateConnector()" blazeBarButton="primary" [disabled]="!formValid">
        {{ createOrUpdateButtonLabel }}
      </button>
    </ng-container>
  }
  <div content class="dialog-content">
    <blaze-form-builder
      #formBuilder
      (formData)="updateFormValues($event)"
      (formValid)="updateFormValid($event)"
      [formConfig]="formConfig$ | async"
      [initialValues]="initialFormValues"
    />
    <blaze-element-loading-indicator [isVisible]="loadingForm()" />
  </div>
</blaze-panel>
